export const BUREAUS = ["equifax", "experian", "transunion"] as const;

export function ficoMain(values: Record<string, number>) {
  const scores = BUREAUS.map((key) => values[key]).filter((n) => n != null);
  if (scores.some((n) => !Number.isInteger(n) || n < 300 || n > 850)) throw new Error("Each score must be 300–850");
  scores.sort((a, b) => a - b);
  if (scores.length === 3) return scores[1];
  if (scores.length === 2) return Math.round((scores[0] + scores[1]) / 2);
  return scores[0] ?? 0;
}

export function entryDate(date = new Date()) {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
}

export function recordedAt(day: string) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) throw new Error("Choose a valid entry date");
  const date = new Date(`${day}T12:00:00`);
  if (!Number.isFinite(date.getTime()) || entryDate(date) !== day) throw new Error("Choose a valid entry date");
  return date.toISOString();
}

export function chronological<T extends { recorded_at: string }>(rows: T[]) {
  return [...rows].sort((a, b) => a.recorded_at.localeCompare(b.recorded_at));
}

export function assertRealMetricWrite(practice: boolean, metric: string) {
  if (practice && ["fico", "savings", "debt"].includes(metric)) throw new Error("Turn off Practice mode to save your real financial records.");
}

export function historyDate(date: string) {
  const parsed = new Date(date.length === 10 ? `${date}T12:00:00` : date);
  return Number.isFinite(parsed.getTime()) ? parsed.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "Date unavailable";
}